const ANNUAL_UPDATE_LOGS_STATUSES = {
  readyToUpdate: 'ready_to_update',
  dataConfirmed: 'data_confirmed'
};

export default ANNUAL_UPDATE_LOGS_STATUSES;
